import { IComponentOptions } from "angular";
import { PartTransactionItemController } from "../partTransactionItemController";

export const vsComponentName = "partTransactionDetailCheckedOutPart";

export const partTransactionDetailCheckedOutPartComponent: IComponentOptions = {
  bindings: {
    item: "<",
  },
  controller: PartTransactionItemController,
  controllerAs: "ctrl",
  template: require("!html-loader!./index.html").default,
};
